<template>
	<Divider v-bind="$attrs" :orientation="realOrientation" :class="{ 'divider-auto-small': small }">
		<slot />
	</Divider>
</template>

<script>
import { computed, toRef } from 'vue';
import { Divider } from 'ant-design-vue';

import { useLocaleData } from '@/locales/useLocaleData';


export default {
	components: { Divider },
	props: {
		orientation: {
			type: String,
			default: 'left',
		},
		small: {
			type: Boolean,
			default: false,
		},
	},
	setup(props) {
		const orientation = toRef(props, 'orientation');
		const { directionLTR } = useLocaleData();
		const realOrientation = computed(() => {
			if (orientation.value === 'center') {
				return 'center';
			}
			if (orientation.value === 'left') {
				return directionLTR.value ? 'left' : 'right';
			}
			return directionLTR.value ? 'right' : 'left';
		});
		return { realOrientation };
	},
}
</script>

<style scoped>
.divider-auto-small.ant-divider-with-text {
	font-size: 12px;
}

.divider-auto-small :deep(.ant-divider-inner-text) {
	padding-inline: 4px;
}
</style>
